"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _LoaderElements = require("./Components/LoaderElements.js");
var _jsxRuntime = require("react/jsx-runtime");
var _InnerLoader;
const Loader = props => {
  const {
    size,
    className,
    isFullPage = false
  } = props;
  const LoaderComponent = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoaderElements.LoaderContainer, {
    className: `Mun-DS-loader ${className ?? ''}`,
    isFullPage: isFullPage,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoaderElements.OuterLoader, {
      size: size,
      className: "Mun-DS-loader__container",
      children: _InnerLoader || (_InnerLoader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoaderElements.InnerLoader, {
        className: "Mun-DS-loader__container--loader"
      }))
    })
  });
  return isFullPage ? /*#__PURE__*/(0, _reactDom.createPortal)(LoaderComponent, document.body) : LoaderComponent;
};
var _default = exports.default = Loader;
module.exports = exports.default;
module.exports.default = exports.default;